import React from 'react'
import { Button } from '@mote/ui'
import { ImportCSVDialog } from './dialogs/ImportCSVDialog'
import { CancellationConfirmationDialog } from './dialogs/CancellationConfirmationDialog'
import { ImportSuccessConfirmationDialog } from './dialogs/importSuccessConfirmationDialog'
import { ImportScheduledDialog } from './dialogs/importScheduledDialog'
import styled from 'styled-components'

const DIALOGS = {
  IMPORT_CSV_DIALOG: 'IMPORT_CSV_DIALOG',
  CANCELLATION_CONFIRMATION_DIALOG: 'CANCELLATION_CONFIRMATION_DIALOG',
  IMPORT_SUCCESS_CONFIRMATION_DIALOG: 'IMPORT_SUCCESS_CONFIRMATION_DIALOG',
  IMPORT_SCHEDULED_DIALOG: 'IMPORT_SCHEDULED_DIALOG'
}

export const ImportCSVButton = () => {
  const [currentDialog, setCurrentDialog] = React.useState()
  const [previousDialog, setPreviousDialog] = React.useState(null)
  const [uploadMeta, setUploadMeta] = React.useState(null)

  function openDialog() {
    setCurrentDialog(DIALOGS.IMPORT_CSV_DIALOG)
  }

  function closeDialog() {
    setCurrentDialog(null)
  }

  function toggleCancellationConfirmationDialog() {
    setPreviousDialog(currentDialog)
    setCurrentDialog(DIALOGS.CANCELLATION_CONFIRMATION_DIALOG)
  }

  function handleSwitchToPreviousScreen() {
    setCurrentDialog(previousDialog ?? DIALOGS.IMPORT_CSV_DIALOG)
  }

  function handleUploadSuccess(upload) {
    setUploadMeta(upload)
    setCurrentDialog(DIALOGS.IMPORT_SUCCESS_CONFIRMATION_DIALOG)
  }

  function handleImportConfirmation() {
    setPreviousDialog(currentDialog)
    setCurrentDialog(DIALOGS.IMPORT_SCHEDULED_DIALOG)
  }

  return (
    <>
      <DialogBackdrop isOpen={Boolean(currentDialog)} />
      <Button text='Import CSV' variant='primary' onClick={openDialog} />

      {currentDialog === DIALOGS.IMPORT_CSV_DIALOG && (
        <ImportCSVDialog
          onUploadSuccess={handleUploadSuccess}
          onDialogDismissal={toggleCancellationConfirmationDialog}
        />
      )}

      {currentDialog === DIALOGS.CANCELLATION_CONFIRMATION_DIALOG && (
        <CancellationConfirmationDialog
          switchToPreviousScreen={handleSwitchToPreviousScreen}
          onDialogDismissal={closeDialog}
        />
      )}

      {currentDialog === DIALOGS.IMPORT_SUCCESS_CONFIRMATION_DIALOG && (
        <ImportSuccessConfirmationDialog
          uploadMeta={uploadMeta}
          onImportConfirmation={handleImportConfirmation}
          onDialogDismissal={toggleCancellationConfirmationDialog}
          onShowPreviousScreen={handleSwitchToPreviousScreen}
        />
      )}

      {currentDialog === DIALOGS.IMPORT_SCHEDULED_DIALOG && (
        <ImportScheduledDialog onDialogDismissal={closeDialog} />
      )}
    </>
  )
}

const DialogBackdrop = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'initial' : 'none')};
  opacity: 0.4;
  user-select: none;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  z-index: 97;
  overflow: auto;
  background: rgba(0, 0, 0, 0.25);
`
